import {getAvatarColorIndex} from './avatar-color';
import {cn} from '../../lib/utils';
import {Avatar as ShadcnAvatar, AvatarFallback, AvatarImage} from '../shadcn/avatar';

import type {AvatarShape, AvatarSize} from './avatar-variants';
import type {Avatar as AvatarPrimitive} from '@base-ui/react/avatar';

export interface AvatarProps extends Omit<AvatarPrimitive.Root.Props, 'children'> {
  initials: string;
  size?: AvatarSize;
  shape?: AvatarShape;
  src?: string;
  alt?: string;
  noShadow?: boolean;
  colorIndex?: number;
  seed?: string;
}

export function Avatar({
  initials,
  size = 'default',
  shape = 'circle',
  src,
  alt,
  noShadow,
  colorIndex,
  seed,
  className,
  ...props
}: AvatarProps) {
  const resolvedColorIndex =
    colorIndex ?? (seed !== undefined ? getAvatarColorIndex(seed) : undefined);
  const letter = ([...initials][0] ?? '').toUpperCase();

  return (
    <ShadcnAvatar
      // Forces a remount on src removal — Base UI never resets its stuck 'loaded' status otherwise.
      key={src ? 'image' : 'fallback'}
      size={size}
      shape={shape}
      className={cn(noShadow && 'shadow-none', className)}
      {...props}
    >
      {src ? (
        <>
          <AvatarImage src={src} alt={alt ?? initials} />
          <AvatarFallback colorIndex={resolvedColorIndex}>{letter}</AvatarFallback>
        </>
      ) : (
        <AvatarFallback colorIndex={resolvedColorIndex}>{letter}</AvatarFallback>
      )}
    </ShadcnAvatar>
  );
}
